import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
interface Slide8Props {
  onNavigate: (slide: number) => void;
}
export function Slide8({
  onNavigate
}: Slide8Props) {
  const menuItems = [{
    title: 'Medical information & contact',
    slide: 9
  }, {
    title: 'Pregnancy considerations',
    slide: 10
  }, {
    title: 'Full prescribing information',
    slide: 11
  }];
  return <SlideLayout data-id="element-231">
      <div className="w-full max-w-4xl mx-auto space-y-12" data-id="element-232">
        <h1 className="text-4xl font-bold text-primary text-center mb-16" data-id="element-233">
          Additional information
        </h1>
        <div className="grid grid-cols-1 gap-6" data-id="element-234">
          {menuItems.map((item, index) => <button key={index} onClick={() => onNavigate(item.slide)} className="bg-white border-2 border-primary rounded-xl p-8 hover:bg-primary hover:text-white transition-all duration-300 hover:shadow-2xl group" data-id="element-235">
              <div className="flex items-center justify-between" data-id="element-236">
                <span className="text-xl font-semibold text-left" data-id="element-237">
                  {item.title}
                </span>
                <span className="text-3xl text-accent group-hover:text-highlight transition-colors" data-id="element-238">
                  →
                </span>
              </div>
            </button>)}
        </div>
      </div>
    </SlideLayout>;
}